@if (chartCsv) {
  <div class="acquisition-chart-wrapper acquisition-chart">
    <channel-list
      [title]="'Available Channels'"
      [defaultChannels]="defaultChannels"
      [selectDefaultChannels]="selectDefaultChannels"
      [channels]="channelsCheckList"
      [virtualScrollWidth]="340"
      (selectDefault)="selectDefault()"
      (deSelectAll)="deselectAll()"
      (channelListChanged)="channelListChanged()"
      (unitSystemChanged)="onUnitSystemChanged($event)">
    </channel-list>
    @if (channelsCheckList.length && chartOptions['series'].length) {
      <div class="chart-wrapper">
        @if (acquisitionDataService.data$ | async) {
          <ct-chart
            [dataProvider]="acquisitionDataService"
            [options]="chartOptions"
            class="chart">
          </ct-chart>
        }
      </div>
    }
  </div>
}

<div id="progressContainer"></div>
